var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import * as React from "react";
import { useEffect } from "react";
import { useQuery } from "react-query";
import Property from "./Property";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Autocomplete, CircularProgress, IconButton, Menu, MenuItem, Stack } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useService } from "../utils/hooks/services/useServices";
import { ServiceService } from "../services/service/service.service";
import { debounce } from "lodash";
import { useReadOnly } from "../utils/hooks/users/useReadOnly";
var ServiceInfoRow = function (_a) {
    var serviceId = _a.serviceId, setServiceId = _a.setServiceId, disabled = _a.disabled, onDelete = _a.onDelete, index = _a.index, id = _a.id, sector = _a.sector, tooltip = _a.tooltip;
    var t = useTranslation().t;
    var readOnly = useReadOnly();
    var service = useService(serviceId);
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var _c = React.useState(''), query = _c[0], setQuery = _c[1];
    var _d = React.useState(''), debouncedQuery = _d[0], setDebouncedQuery = _d[1];
    var searchServicesQuery = useQuery(['allServices', debouncedQuery, sector === null || sector === void 0 ? void 0 : sector.id], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServiceService.getAllServices({
                        name: debouncedQuery ? [debouncedQuery] : undefined,
                        sectorIds: [sector.id],
                        limit: {
                            offset: 0,
                            limit: 10000,
                            sort: [{ field: "name", direction: "ASC" }]
                        }
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); }, { enabled: !!(sector === null || sector === void 0 ? void 0 : sector.id) });
    var debouncedSearch = React.useMemo(function () {
        return debounce(function (q) {
            setDebouncedQuery(q);
        }, 500);
    }, []);
    useEffect(function () {
        debouncedSearch(query);
        return function () {
            debouncedSearch.cancel();
        };
    }, [query, debouncedSearch]);
    var viewServiceButton = !!serviceId && (_jsx(Button, __assign({ endIcon: _jsx(OpenInNewIcon, {}), sx: { minWidth: 'fit-content' }, onClick: function () {
            window.open("/system/services/".concat(serviceId), '_blank');
        } }, { children: t('View') })));
    var moreButton = !!serviceId && !disabled && !readOnly && !!onDelete && (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({ id: "more-menu-item-".concat(index), "aria-controls": open ? "basic-menu-item-".concat(index) : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick, sx: {
                    width: 36.5,
                    height: 36.5,
                    borderRadius: 1,
                } }, { children: _jsx(MoreVertIcon, {}) })), _jsx(Menu, __assign({ id: "basic-menu-item-".concat(index), anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                    'aria-labelledby': 'basic-button',
                } }, { children: _jsx(MenuItem, __assign({ onClick: function () {
                        onDelete();
                        handleClose();
                    } }, { children: t('Delete') })) }))] }));
    var rowActions = (viewServiceButton || moreButton) && (_jsxs(Stack, __assign({ direction: 'row', alignItems: 'center', gap: 1 }, { children: [viewServiceButton, moreButton] })));
    if (serviceId) {
        return (_jsx(Property, __assign({ title: t('Service'), tooltip: tooltip, actions: rowActions }, { children: _jsx(_Fragment, { children: _jsx(TextField, { id: 'service', size: 'small', value: (service === null || service === void 0 ? void 0 : service.name) || '', fullWidth: true, disabled: disabled }) }) })));
    }
    else {
        return (_jsx(Property, __assign({ title: t('Service'), tooltip: tooltip, actions: rowActions }, { children: _jsx(_Fragment, { children: _jsx(Autocomplete
                // id="service-find"
                , { 
                    // id="service-find"
                    id: id, onOpen: function () {
                        searchServicesQuery.refetch();
                    }, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.name || ''; }, options: searchServicesQuery.data || [], loading: searchServicesQuery.isLoading, filterOptions: function (x) { return x; }, fullWidth: true, onChange: function (_e, value) {
                        if (value) {
                            setServiceId === null || setServiceId === void 0 ? void 0 : setServiceId(value === null || value === void 0 ? void 0 : value.id);
                        }
                    }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { size: 'small', fullWidth: true, onChange: function (e) {
                            setQuery(e.target.value);
                        }, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(React.Fragment, { children: [searchServicesQuery.isLoading ?
                                        _jsx(CircularProgress, { color: "inherit", size: 20 }) : null, params.InputProps.endAdornment] })) }) }))); }, disabled: disabled }) }) })));
    }
};
export default ServiceInfoRow;
